module.exports = __webpack_public_path__ + "img/logo_landing@2x.bc3ee0f7.png";